import React, { useRef, useEffect } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import './PurchaseResultModal.css';

function PurchaseResultModal({ isOpen, onClose, result, selectedOption, price, quantity }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const title = result === 'success' ? 'Purchase Successful!' : 'Purchase Failed';
  let message = '';

  if (result === 'success') {
    if (selectedOption === "Single Day Pass" || selectedOption === "Five Day Passes") {
      const multiplier = selectedOption === "Single Day Pass" ? 1 : 5;
      const totalPasses = multiplier * quantity;
      message = `You have successfully purchased ${totalPasses} Day Pass${totalPasses > 1 ? 'es' : ''} for $${price}.`;
    } else {
      message = `You have successfully purchased ${quantity} ${selectedOption}${quantity > 1 ? 'es' : ''} for $${price}.`;
    }
  } else {
    message = 'Unfortunately, your purchase could not be completed. Please try again or contact support.';
  }

  return (
    <div className="modal-overlay">
      <div className="purchase-modal-content" ref={overlayRef}>
        <button className="close-button" onClick={onClose}>×</button>
        {result === 'success' ? (
          <FaCheckCircle className="success-icon" />
        ) : (
          <FaTimesCircle className="error-icon" />
        )}
        <h3 className="purchase-modal-title">{title}</h3>
        <p>{message}</p>
        <button className="close-modal-button" onClick={onClose}>
          {result === 'success' ? 'Sweet!' : 'Try Again'}
        </button>
      </div>
    </div>
  );
}

export default PurchaseResultModal;
